import { detectAdBlock } from "@product/scmp-sdk";
import { useAsync, useMountEffect } from "@react-hookz/web";

import { isExternalScriptsDisabled } from "~/lib/utils";

export function useDetectAdBlock() {
  const [state, { execute }] = useAsync(async () => {
    if (isExternalScriptsDisabled()) return true;
    const hasAdBlock = await detectAdBlock();
    return hasAdBlock;
  });
  useMountEffect(execute);
  return state;
}
